import DecisionNodeBase from '~/models/journey/DecisionNodeBase'
import type { WaypointNode } from '~/models/journey/waypoints'
import type { Path } from '~/types/util'
import { SiteStore } from '~/stores/site'
import { SessionStore } from '~/stores/session'
import { PlanType } from '~/generated/api-clients-generated'

export default class GuidedRecEnabledNode extends DecisionNodeBase {
  getNext(): WaypointNode | Path | null {
    const { flag } = FeatureFlags.use()
    const site = SiteStore.use()
    const session = SessionStore.use()

    const guidedRecJourneys = flag<number[]>('guided-rec')

    return this.yesNo(
      session.planType === PlanType.MAPD && guidedRecJourneys.value.includes(site.journey.id ?? 0)
    )
  }
}
